import React, { useState } from "react";
import Layout from "../../../components/Layout";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListBodyItemStatus,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemAction,
} from "../../../components/_widgets/WidgetsList";
require("dotenv").config();

function Invoice() {
  const [qtListItem, setQtListItem] = useState(10);
  return (
    <>
      <Layout defaultMenu={1} title={"Faturas Renner"} link={"#"}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex justify-content-end">
            {/* <BlackWhiteButton
              className="mb-3"
              size={12}
              sizeLg={9}
              text="Exportar planilha"
            /> */}
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List onChange={(e) => setQtListItem(e.target.value)} value={qtListItem} totalItem={16}>
              <ListHeader>
                <ListHeaderItem sizeLg={2} title={"Valor"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[
                        { name: "Todos" },
                        { name: "Food" },
                        { name: "Moda" },
                        { name: "Pet" },
                        { name: "Beleza" },
                        { name: "Farmácia" },
                      ].map((item) => (
                        <div className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Data"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[
                        { name: "Todos" },
                        { name: "Food" },
                        { name: "Moda" },
                        { name: "Pet" },
                        { name: "Beleza" },
                        { name: "Farmácia" },
                      ].map((item) => (
                        <div className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Status"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      {[
                        { name: "Todos" },
                        { name: "Food" },
                        { name: "Moda" },
                        { name: "Pet" },
                        { name: "Beleza" },
                        { name: "Farmácia" },
                      ].map((item) => (
                        <div className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={6} title={""} />
              </ListHeader>
              <ListBody>
                {[
                  {
                    price: "R$ 99,90",
                    date: "23/12/2022",
                    state: "Ativo",
                  },
                ].map((item, index) =>
                  index + 1 <= qtListItem ? (
                    <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                      <ListBodyItem sizeLg={2} description={"Valor"} title={item.price} />
                      <ListBodyItem sizeLg={2} description="Data" title={item.date} />
                      <ListBodyItemStatus
                        sizeLg={2}
                        className={
                          true
                            ? "bg-cl-aero-blue border-forest-green text-cl-forest-green"
                            : "border-venetian-red bg-cl-pale-pink text-cl-venetian-red"
                        }
                        description={"Status"}
                        title={item.state}
                      />
                      <ListBodyItemAction sizeLg={6} title={"edit"}>
                        <li>
                          <span
                            className="dropdown-item fz-14 ff-univanova-regular c-pointer text-decoration-underline text-cl-azure"
                            data-bs-toggle="modal"
                            data-bs-target="#myModalSingle"
                          >
                            Editar
                          </span>
                        </li>
                        <li>
                          <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer text-decoration-underline text-cl-red">
                            Excluir
                          </span>
                        </li>
                      </ListBodyItemAction>
                    </ListBodyCell>
                  ) : (
                    <></>
                  )
                )}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Invoice;
